const endpoint = "https://mpbb.cuba-games.com"
const cpoint = "https://central-backend.cuba-lv.com"
const mediapoint = `https://s3-media.cuba-lv.com`
const startpoint = `${cpoint}/`

const internetSpeedImgLink = "https://central-backend.cuba-lv.com/images/dealerinfo/close.png"
const gamePlace = { studio: "bishkek", room: "table5-room" } //bishkek, tbilisi

export { endpoint, mediapoint, startpoint, internetSpeedImgLink, gamePlace }
